import React from 'react';
import BasicModal from 'components/organisms/Modal/Basic';
import BasicModalHeader from 'components/molecules/Modal/Header';
import BasicModalSection from 'components/molecules/Modal/Section';
import BasicModalFooter from 'components/molecules/Modal/Footer';
import { useTranslation } from 'react-i18next';
import Statistics from '../TimeStatistics/Statistics';
import moment from 'moment';

const GraphModal = (props) => {
  const { params, handleToggleModal, isOpen } = props;
  const { t } = useTranslation();

  const label = t('최근 30일 데이터 입니다.');
  const handleModalClose = () => {
    handleToggleModal(false);
  };

  const modalParams = {
    ...params,
    sDate: moment(moment().subtract(30, 'days').format('YYYYMMDD')),
    eDate: moment().format('YYYYMMDD'),
  };

  return (
    <>
      <BasicModal open={isOpen} width={'100%'}>
        <BasicModalHeader
          headerOpen={true}
          headerTitle={label}
          closeBtn
          closeOnClick={handleModalClose}
        ></BasicModalHeader>
        <BasicModalSection>
          <Statistics
            initParam={{ ...modalParams }}
            switchDatas={['weekday', 'weekend']}
            graphType="01"
          />
        </BasicModalSection>
        <BasicModalFooter
          comfirmOnClick={true}
          cancelOnClick={handleModalClose}
          comfirmBtnOpen={false}
          cancelBtnOpen={true}
          cancelBtnTitle={t('확인')}
        />
      </BasicModal>
    </>
  );
};
export default GraphModal;
